import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Navbar.css';

import logo from '../../assets/images/logo.png';

const NAV_LINKS = [
  { to: '/',              label: 'Home'         },
  { to: '/about',         label: 'About'        },
  { to: '/team',          label: 'Our Team'     },
  { to: '/membership',    label: 'Membership'   },
  { to: '/get-involved',  label: 'Get Involved' },
  { to: '/shop',           label: 'Shop'         },
  { to: '/blog',          label: 'Blog'         },
  { to: '/gallery',       label: 'Gallery'      },
  { to: '/contact',       label: 'Contact'      },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  const toggleMenu = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  // Close menu on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeMenu]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <header className="navbar" role="banner">
      <div className="navbar__inner">

        {/* Logo */}
        <Link
          to="/"
          className="navbar__logo"
          aria-label="Nuclear Society of Kenya — Home"
          onClick={closeMenu}
        >
          <img
            src={logo}
            alt="NSK Logo"
            className="navbar__logo-img"
          />
          <div className="navbar__logo-text">
            <span className="navbar__logo-title">Nuclear Society</span>
            <span className="navbar__logo-sub">of Kenya</span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="navbar__nav" aria-label="Main navigation">
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `navbar__link${isActive ? ' active' : ''}`
              }
            >
              {label}
            </NavLink>
          ))}
          <Link to="/join" className="btn btn--primary navbar__cta">
            Join NSK
          </Link>
        </nav>

        {/* Hamburger Button */}
        <button
          className="navbar__hamburger"
          onClick={toggleMenu}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className={`navbar__bar navbar__bar--top ${menuOpen ? 'open' : ''}`} />
          <span className={`navbar__bar navbar__bar--mid ${menuOpen ? 'open' : ''}`} />
          <span className={`navbar__bar navbar__bar--bottom ${menuOpen ? 'open' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <nav
        id="mobile-menu"
        className={`navbar__mobile-menu ${menuOpen ? 'open' : ''}`}
        aria-label="Mobile navigation"
        aria-hidden={!menuOpen ? 'true' : 'false'}
        {...(!menuOpen && { inert: '' })}
      >
        {NAV_LINKS.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `navbar__mobile-link${isActive ? ' active' : ''}`
            }
            onClick={closeMenu}
          >
            {label}
          </NavLink>
        ))}
        <Link
          to="/join"
          className="btn btn--primary navbar__mobile-cta"
          onClick={closeMenu}
        >
          Join NSK
        </Link>
      </nav>
    </header>
  );
}

export default Navbar;